export default class {
    constructor ($rootScope, TokenService, UserResource, AuthResource, localStorageService, $state, IdBouncerResource) {
        this.TokenService = TokenService;
        this.UserResource = UserResource;
        this.localStorageService = localStorageService;
        this.$state = $state;
        this.IdBouncerResource = IdBouncerResource;
        $rootScope.$on('token:refresh', () => {
            AuthResource.renewToken().$promise.then(() => {
                $rootScope.$broadcast('token:refresh:complete');
            });
        });
    }

    isLoggedIn () {
        const hasToken = this.TokenService.hasToken();
        if (!hasToken) {
            return false;
        }
        const isExpired = this.TokenService.isExpired(this.TokenService.token);
        if (isExpired) {
            this.clearData();
            return false;
        }
        return true;
    }

    loginViaToken (token) {
        const data = this.TokenService.decode(token);
        const userId = data.context.user.id;
        return this.UserResource.get({ id: userId }).$promise;
    }

    logout () {
        this.logoutFromIdBouncer();
        this.clearData();
    }

    // Fire and forget, a failing bouncer session cleanup must never block the local logout
    logoutFromIdBouncer () {
        if (!this.IdBouncerResource) {
            return;
        }
        this.IdBouncerResource.idCardLogout({}, {}).$promise.catch(() => {});
    }

    logoutAndRedirect () {
        const companySlug = this.TokenService.getCompanySlug();
        this.logout();
        this.$state.go('home', { company: companySlug });
    }

    clearData () {
        this.TokenService.clear();
        this.localStorageService.remove('coursy:auth:sites');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/index.js